import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// maintenance routing
const GeneralError = Loadable(lazy(() => import('views/pages/maintenance/GeneralError')));
const InternalServerError = Loadable(lazy(() => import('views/pages/maintenance/InternalServerError')));
const UnauthorizedError = Loadable(lazy(() => import('views/pages/maintenance/Unauthorized')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/error',
            element: <GeneralError />
        },
        {
            path: '/internal-server-error',
            element: <InternalServerError />
        },
        {
            path: '/unauthorized',
            element: <UnauthorizedError />
        },
        {
            path: '/under-construction',
            element: <MaintenanceUnderConstruction />
        }
    ]
};

export default AuthenticationRoutes;
